import { createSlice } from "@reduxjs/toolkit";

export interface notificationRefreshState {
  refreshNotifications: boolean;
  refreshNotifTable: boolean;
  refreshExercises: boolean;
}

const initialState: notificationRefreshState = {
  refreshNotifications: true,
  refreshNotifTable: true,
  refreshExercises: true,
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState: initialState,
  reducers: {
    setRefreshNotification: (state) => {
      state.refreshNotifications = !state.refreshNotifications;
    },
    setRefreshNotifTable: (state) => {
      state.refreshNotifTable = !state.refreshNotifTable;
    },
    setRefreshExercises: (state) => {
      state.refreshExercises = !state.refreshExercises;
    },
  },
});

export const {
  setRefreshNotification,
  setRefreshNotifTable,
  setRefreshExercises,
} = notificationSlice.actions;

export default notificationSlice.reducer;
